import React from "react";
import { Grid } from "semantic-ui-react";

import useWindowDimensions from "../../hooks/windowsSize";
import { CustomButton, CustomButtonProps } from "../button/Button";

import "./mainBottomButton.scss";

interface ButtonProps {
  title: string;
  onClick: () => void;
  theme?: CustomButtonProps["theme"];
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  buttonOutLine?: boolean;
  ghost?: boolean;
  bounceEffect?: boolean;
  contentView?: any | 4;
  buttonView?: boolean | true;
  iconWithText?: boolean;
  iconChild?: React.ReactNode;
  iconChildTextCustom?: string;
}

interface MainBottomButtonViewProps {
  customHeight?: number | null;
  leftButtons?: ButtonProps[];
  rightButtons?: ButtonProps[];
  customBottomContentMain?: string;
  testId?: string;
}

const MainBottomMultipleButtonView: React.FC<MainBottomButtonViewProps> = ({
  customHeight = null,
  leftButtons = [],
  rightButtons = [],
  customBottomContentMain = "",
  testId
}) => {
  const { height } = useWindowDimensions();
  const heightView = customHeight || height * 0.1;

  return (
    <Grid
      style={{ height: heightView }}
      className={`p-1 bottomButtonContent ${customBottomContentMain}`}
    >
      <Grid.Row columns={2}>
        <Grid.Column computer={8} tablet={16} mobile={16}>
          <Grid>
            {leftButtons.map((btn, index) => {
              const leftButtonsView = btn?.contentView ? btn?.contentView : 4;
              const showButton = btn?.buttonView ?? true;
             
              if (showButton) {
                return (
                  <Grid.Column
                    key={index}
                    computer={leftButtonsView}
                    tablet={16}
                    mobile={16}
                    className="pb-0"
                  >
                    <CustomButton
                      theme={btn.theme || "green"}
                      title={btn.title}
                      onClick={btn.onClick}
                      buttonOutLine={btn.buttonOutLine}
                      ghost={btn.ghost}
                      className={btn.bounceEffect ? "bounce-effect" : ""}
                      iconWithText={btn.iconWithText}
                      iconChild={btn.iconChild}
                      iconChildTextCustom={btn.iconChildTextCustom}
                      disabled={btn.disabled}
                      testId={testId ? `${testId}-left-button-${index}` : undefined}
                    />
                  </Grid.Column>
                );
              }
            })}
          </Grid>
        </Grid.Column>
        <Grid.Column computer={8} tablet={16} mobile={16} textAlign="right" className="pb-0">
          <Grid>
            {rightButtons.map((btn, index) => {
              const rightButtonsView = btn?.contentView ? btn?.contentView : 4;
              const btnTestId = btn?.title ? btn.title.toLowerCase().replace(/\s+/g, "-") : `button-${index}`;
              if (btn?.buttonView) {
                return (
                  <Grid.Column
                    key={index}
                    computer={rightButtonsView}
                    tablet={16}
                    mobile={16}
                    className="pb-0"
                  >
                    <CustomButton
                      key={index}
                      theme={"green"}
                      title={btn.title}
                      onClick={btn.onClick}
                      type={btn.type || "button"}
                      disabled={btn.disabled}
                      buttonOutLine={btn.buttonOutLine}
                      className={btn.bounceEffect ? "bounce-effect" : ""}
                      testId={testId ? `${testId}-right-button-${btnTestId}` : undefined}
                    />
                  </Grid.Column>
                );
              }
            })}
          </Grid>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default MainBottomMultipleButtonView;
